<template>
  <section class="group">
    <el-card class="">
      <div class="header-card">
        <div class="header">
        <el-select v-model="group_id" filterable placeholder="">
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="place_name" filterable placeholder="">
          <el-option
            v-for="item in placeNameList"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" @click="handleQuery">查询</el-button>
        <el-button type="secondary" size="small" @click="handleReset">重置</el-button>
      </div>
      <div class="action">
        <el-button type="primary" @click="handleUpload(1)">上传</el-button>
        <el-button type="primary" @click="handleUpload(2)">下载</el-button>
      </div>
      </div>
    </el-card>
    <el-card>
      <el-table
        v-if="tableData"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="group_id"
          label="Group ID"
          width="180">
        </el-table-column>
        <el-table-column
          prop="place_name"
          label="场"
          width="180">
        </el-table-column>
        <el-table-column
          prop="floor"
          label="楼层">
        </el-table-column>
        <el-table-column
          prop="ar_id"
          label="AR ID">
        </el-table-column>
        <el-table-column
          prop="status_verbose"
          label="建图状态">
          <!-- <template slot-scope="scope">
            <span>{{scope.status_verbose}}</span>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="stage_status"
          label="阶段">
        </el-table-column>
        <el-table-column
          prop="test_status"
          label="测试视频结果">
          <template slot-scope="scope">
            <span>{{scope.dynamic_success_rate * 100 || '--'}}%</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-if="!tableData">
          <el-empty description="正在加载数据"></el-empty>
      </template>
      <div class="pagi">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="pageCount * 10">
        </el-pagination>
        <el-pagination :total="10" :current-page="1" :page-size="10" @current-change="handlePage" layout=""></el-pagination>
      </div>
    </el-card>
    <el-dialog title="" :visible.sync="showDetail">
      <el-descriptions title="用户信息">
        <el-descriptions-item label="场名称">{{detailInfo.place_name}}</el-descriptions-item>
        <el-descriptions-item label="楼层">{{detailInfo.floor}}</el-descriptions-item>
        <el-descriptions-item label="AR ID">{{detailInfo.ar_id}}</el-descriptions-item>
        <el-descriptions-item label="VR ID">
          {{detailInfo.vr_id}}
        </el-descriptions-item>
        <el-descriptions-item label="建图状态">{{detailInfo.map_status}}</el-descriptions-item>
        <el-descriptions-item label="阶段">{{detailInfo.map_stage}}</el-descriptions-item>
        <el-descriptions-item label="预估建图时间">{{detailInfo.evaluate_time}}</el-descriptions-item>
        <el-descriptions-item label="实际建图耗时">{{detailInfo.actual_time}}</el-descriptions-item>
        <el-descriptions-item label="是否服务部署">{{detailInfo.deploy_status}}</el-descriptions-item>
        <el-descriptions-item label="测试视频结果">{{detailInfo.dynamic_success_rate * 100}}%</el-descriptions-item>
        <el-descriptions-item label="可视化链接">{{detailInfo.result_url}}</el-descriptions-item>
        <el-descriptions-item label="测试视频链接">{{detailInfo.url}}</el-descriptions-item>
        <el-descriptions-item label="Replay Token">{{detailInfo.replay_token}}</el-descriptions-item>
        <el-descriptions-item label="扫场时间">{{detailInfo.robot_scanning_time}}</el-descriptions-item>
        <el-descriptions-item label="算法版本">{{detailInfo.algorithm_version}}</el-descriptions-item>
        <el-descriptions-item label="是否上线">{{detailInfo.online === 0 ? '未上线' : '已上线'}}</el-descriptions-item>
        <el-descriptions-item label="是否测试">{{detailInfo.test_status === 0 ? '未测试' : '测试通过'}}</el-descriptions-item>
    </el-descriptions>
    <div class="test-report">
      <div class="report-title">
        测试报告:
      </div>
      <div class="report-content">
        <a v-for="(ele, id) in detailInfo.report_links" :key="id" :href="ele">{{ele}}</a>
      </div>
    </div>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="uploadStatus"
      width="width">
      <el-form label-position="right" label-width="110px">
        <el-form-item label="选择GroupID">
          <div>
            <el-select v-model="group_ids" multiple filterable placeholder="请选择groupID">
              <el-option
                v-for="item in groupCompList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item v-if="download === 1" label="URL">
          <div>
            <el-input v-model="url" placeholder=""></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="uploadStatus = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import axios from "axios";
import excel from '@/utils/excel';

export default {
  name: 'Group',
  data() {
    return {
      STATUS_SOURCES: {
        0: 'ready',
        1: 'running',
        2: 'error',
        3: 'stopped',
        4: 'success',
        5: 'abnormal',
      },
      STAGE_SOURCES: {
        0: '等待运行',
        1: '正在加载原始数据',
        2: '正在拼接图像',
        3: '正在合成全景图',
        4: '正在加载全景图',
        5: '正在建图',
        6: '已完成',
      },
      download: 0,
      tableData: [],
      groupList: [],
      groupList2: [],
      placeNameList: [],
      url: '',
      group_ids: '',
      group_id: '',
      place_name: '',
      title: '',
      detailInfo: {},
      uploadStatus: false,
      pageNum: 1,
      pageCount: 1,
      showDetail: false, // 是否显示详情
    }
  },
  computed: {
    groupCompList() {
      return this.download == 2 ? this.groupList : this.groupList2;
    }
  },
  methods: {
    handleSizeChange(e) {
      console.log(e)
      this.pageNum = e;
      this.handleTables();
    },
    handleCurrentChange(e) {
      this.pageNum = e;
      this.handleTables();
    },
    handlePage(e) {
      console.log(11100, e);
      this.pageNum = e;
    },
    handleConfirm() {
      if (this.download === 1) {
        this.handleUpdateUrl();
        this.handleTables();
      }
      if (this.download === 2) {
        this.handleDownload();
      }
    },
    handleDownload() {
      window.open((`/AR/v1/ar-data/download?group=${this.group_ids.join(',')}`));
    },
    handleUpdateUrl() {
      this.$http.post(`/AR/v1/test-report/upload`, {
        group_id: this.group_ids[0],
        url: this.url
      }).then(res => {
        if (res.data.error_no === 0) {
          this.$message({
            type: 'success',
            message: '上传成功'
          })
          this.uploadStatus = false
        } else {
          this.$message({
            type: 'error',
            message: res.data.error_msg
          })
        }
      })
    },
    handleUpload(idx) {
      this.tile = idx === 1 ? '上传' : '下载';
      this.download = idx;
      this.uploadStatus = true;
    },
    handleQuery() {
      this.handleTables();
    },
    handleReset() {
      this.group_id = '';
      this.place_name = '';
      this.handleTables();
    },
    handleClick(item) {
      this.$http.get(`/AR/v1/ar-data/${item.id}`).then(res => {
        if (res.data.error_no === 0) {
          this.detailInfo = {
            ...res.data.data,
            deploy_status: res.data.data.deploy_status == 0 ? '否' : '是',
            map_stage: this.STAGE_SOURCES[res.data.data.map_stage],
            map_status: this.STATUS_SOURCES[res.data.data.map_status],
          };
          console.log(123123, res.data.data, this.detailInfo);
          this.showDetail = true;
        }
      })
    },
    handleTables() {
      this.$http.get(`/AR/v1/ar-data?group_id=${this.group_id}&place_name=${this.place_name}&page=${this.pageNum}&size=10`).then(res => {
        this.tableData = [];
        console.log(11123000, res.data.data.result);
        if (res.data.error_no === 0) {
          // 有数据
          this.pageCount = res.data.data.pageCount;
          this.pageNum = res.data.data.pageNum;
          this.tableData = res.data.data.result.map(ele => {
            return {
              ...ele,
              status_verbose: this.STATUS_SOURCES[ele.map_status],
              stage_status: this.STAGE_SOURCES[ele.map_stage]
            }
          });
          console.log(11123, this.tableData);
        }
      })
    }
  },
  mounted() {
    this.handleTables();
    this.$http.get('/AR/v1/ar-data-choices').then(res => {
      if (res.data.error_no === 0) {
        const groupList = res.data.data.group_ids.map((ele, id) => {
          return {
            label: ele,
            value: ele,
            id,
          }
        });
        this.groupList2 = JSON.parse(JSON.stringify(groupList));
        groupList.unshift({
          label: '全部',
          value: '',
          id: -1,
        })
        this.groupList = groupList;
        this.placeNameList = res.data.data.place_names.map((ele, id) => {
          return {
            label: ele,
            value: ele,
            id,
          }
        });
      }
    })
  }
}
</script>

<style scoped lang="scss">
.group {
  min-width: 1280px;
  padding: 0 60px;
  width: 100%;
  height: 80vh;
  box-sizing: border-box;
}

.header {
  display: flex;
  width: 700px;
  flex: none;
  align-items: center;
}
.block {
  display: block;
  a {
    display: block;
  }
}
.test-report {
  display: flex;
  font-size: 12px;
}
.report-title {
  flex: none;
  width: 60px;
  margin-right: 5px;
}
.report-content {
  display: flex;
  flex-direction: column;
  line-height: 20px;
  overflow: hidden;
  max-width: 200px;
  text-overflow: ellipsis;
}
/deep/.el-select {
  margin-right: 15px;
}
/deep/.el-input {
  max-width: 220px;
  margin-right: 15px;
}
/deep/.el-card {
  width: 100%;
  margin-bottom: 20px;
}
.header-card {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
/deep/.el-pagination {
  display: flex;
  justify-content: center;
  margin: 20px auto 0;
}
</style>
